import { useState } from "react";

import { useBFFProductServiceApi } from "@api/hooks/productService.hook";
import {
    ProductTileMapper,
    ProductTileModel,
} from "@api/mappers/products.mapper";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

const useAccessories = () => {
    const [accessories, setAccessories] = useState<Array<ProductTileModel>>([]);

    const [{}, loadProducts] = useBFFProductServiceApi(
        {
            url: `/products/:sku`,
            method: "GET",
        },
        {
            manual: true,
            useCache: false,
            autoCancel: false,
        },
    );

    const loadAccessories = (sku: string) => {
        loadProducts({
            urlParams: {
                sku,
            },
        }).then(({ data }) => {
            const productData = data as FullProductApiModel | undefined;
            const accessoriesData = productData?.references.accessories || [];
            if (accessoriesData.length > 0) {
                setAccessories(
                    (productData?.references.accessories || []).map(
                        ProductTileMapper,
                    ),
                );
            }
        });
    };

    return { loadAccessories, accessories };
};

export { useAccessories };
